import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './store/authStore';
import { useStatus } from './hooks/useStatus';
import { MaintenanceScreen } from './components/ui/MaintenanceScreen';
import { PopupNotification } from './components/ui/PopupNotification';
import { AppRoutes } from './routes';
function StatusWrapper({ children }) {
    const status = useStatus();
    if (status.maintenance.enabled) {
        return _jsx(MaintenanceScreen, { title: status.maintenance.title, message: status.maintenance.message, contact_info: status.maintenance.contact_info });
    }
    return (_jsxs(_Fragment, { children: [children, status.popup && _jsx(PopupNotification, { popup: status.popup })] }));
}
export default function App() {
    return (_jsx(BrowserRouter, { children: _jsx(AuthProvider, { children: _jsx(StatusWrapper, { children: _jsx(AppRoutes, {}) }) }) }));
}
